<template>
    <div class="content">
        <div class="header">
            <Area width="1473" @changeSite="changeSite" />
        </div>
        <div class="body">
            <Diagram :src="currentWireURL" :areaId="areaId"  @getDetailData="getDetailData" @loopDetail="loopDetail" @onFull="onFull"
                @onCancelFull="onCancelFull">
                <div slot="table">
                    <!-- <transition name="tableContainer"> -->

                    <div v-if="showTable"
                        :style="'background: rgba(0, 0, 0, 0.5);width:' + width/1920*100 + 'vw;height:' + height/870*100 + 'vh'">
                        <div class="tableBody">
                            <div class="title">
                                <div>实时电力数据一览表</div>
                                <img src="@/assets/img/关闭.png" alt="" @click="showTable = false">
                            </div>
                            <div class="tab" id="diagramTab">
                                <el-tabs v-model="activeName" @tab-click="handleTabClick">
                                    <el-tab-pane label="电压" name="电压">电压</el-tab-pane>
                                    <el-tab-pane label="电流" name="电流">电流</el-tab-pane>
                                    <el-tab-pane label="功率" name="功率">功率</el-tab-pane>
                                    <el-tab-pane v-if="$store.getters.projectId != 4" label="不平衡度" name="不平衡度">不平衡度
                                    </el-tab-pane>
                                </el-tabs>
                            </div>
                            <div class="table" id="diagramTable">
                                <el-table v-if="currentTableData.length > 0" :data="currentTableData"
                                    :span-method="arraySpanMethod" border style="width: 100%"
                                    :header-cell-style="{padding: '0'}" :header-row-style="{ height: 400/108 + 'vh' }"
                                    :row-style="{ height: 400/108 + 'vh' }" :cell-style="{ padding: '0' }">
                                    <el-table-column fixed align="center" prop="loopName" label="回路名称">
                                    </el-table-column>
                                    <el-table-column fixed align="center" prop="node" label="参数名称">
                                    </el-table-column>
                                    <el-table-column fixed align="center" prop="realValue" label="实时数据">
                                    </el-table-column>
                                    <el-table-column fixed align="center" prop="max" label="当日最大值">
                                    </el-table-column>
                                    <el-table-column fixed align="center" prop="max_time" label="最大值时间">
                                    </el-table-column>
                                    <el-table-column fixed align="center" prop="min" label="当日最小值">
                                    </el-table-column>
                                    <el-table-column fixed align="center" prop="min_time" label="最小值时间">
                                    </el-table-column>
                                </el-table>

                                <div v-else class="row-center tip">
                                    <img src="@/assets/img/loading.png" alt="" class="loading">
                                </div>
                                <div class="pagination">
                                    <div>{{'第'+ first + '-' + end + '条/共' + all + '条'}}</div>
                                    <div class="button"
                                        :style="first == 1 || first == 0 ? 'cursor:not-allowed;color:#ccc' : '' "
                                        @click="prev">上一页</div>
                                    <div class="button" :style="end == all ? 'cursor:not-allowed;color:#ccc' : '' "
                                        @click="next">下一页</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- </transition> -->
                </div>
                <div slot="loopDetail" >
                    <LoopDetail :width="width" :height="height" v-if="showLoopDetail" :tab="currentLoopTab"
                        :loopUrl="currentLoopUrl" @closeLoopDetail="showLoopDetail = false"
                        :currentLoop="loops.filter(item => item.subLoopUrl == currentLoopUrl)" />
                </div>
            </Diagram>
        </div>
    </div>
</template>

<script>
    import Area from "@/components/OperatingEnvironment/Area";
    import Diagram from "@/components/wire/Diagram";
    import LoopDetail from "./loopDetail"
    import {
        GET_AREAS,
        GET_WireByProjectId,
        GET_AREA_LOOPS,
        INFLUX_QUERY,
        EXTREMUM_VALUES,
    } from '../../api/common'
    import {
        dateFormat,
    } from "@/util/DateUtil"
    import {
        floatFormat
    } from "@/util/MathUtil"

    import {
        connect,
        destroyConnection,
        subscribeByNodes,
        unsubscribeByNodes,
        subscribebyLoopUrl,
        unsubscribebyLoopUrl
    } from "@/mqtt/loopdata";
    
    import {
        connect as publishConnect,
        destroyConnection as publishDestroyConnection,
    } from "@/mqtt/control";


    export default {
        name: "FirstDiagram",
        components: {
            Area,
            Diagram,
            LoopDetail
        },
        data() {
            return {
                showTable: false,
                areaId: -1,
                wireList: [],
                currentWireURL: '',
                loops: [],
                loopsIdArr: [],
                activeName: '电压',

                extremNodes: ['Ua', 'Ub', 'Uc'],
                requestRes: [],
                nodes: ["Ua", "Ub", "Uc", "Ia", "Ib", "Ic", "PA", "PR", "P", "PF", "U_unbl", "I_unbl", "SwitchOn"],

                first: 0,
                end: 0,
                all: 0,
                currentTableData: [],


                showLoopDetail: false,
                currentLoopTab: '',
                currentLoopUrl: '',

                width: 1600,
                height: 870,
            }
        },
        computed: {
            tableData() {
                if (this.requestRes.length === 0) {
                    return []
                }
                let data = []
                this.loops.map(l => {
                    this.extremNodes.map(n => {
                        let obj = {}
                        this.requestRes.forEach((res, index) => {
                            obj['loopName'] = l.loopName
                            obj['node'] = this.getChinese(n) + this.getUnit(n)
                            let extremum = res.data.data.extremum;
                            for (let k in extremum) {
                                if (extremum.hasOwnProperty(k)) {
                                    var start = k.indexOf("/");
                                    var s = k.substring(start + 1);
                                    extremum[s] = extremum[k]
                                }
                            }
                            // console.log(extremum)
                            if (typeof (extremum) == 'undefined')
                                return []
                            // console.log(extremum[`${l.subLoopUrl}_${n}`])
                            if (extremum[`${l.subLoopUrl}_${n}`]) {
                                if (index === 0) {
                                    obj['max'] = floatFormat(extremum[`${l.subLoopUrl}_${n}`]
                                        .max, 3)
                                    obj['max_time'] = this.timeGenerate(extremum[
                                        `${l.subLoopUrl}_${n}`].time)
                                }
                                if (index === 1) {
                                    obj['min'] = floatFormat(extremum[`${l.subLoopUrl}_${n}`]
                                        .min, 3)
                                    obj['min_time'] = this.timeGenerate(extremum[
                                        `${l.subLoopUrl}_${n}`].time)
                                }
                            } else {
                                if (index === 0) {
                                    obj['max'] = '--'
                                    obj['max_time'] = '--'
                                }
                                if (index === 1) {
                                    obj['min'] = '--'
                                    obj['min_time'] = '--'
                                }
                            }
                            obj['realValue'] = this.$store.getters.mqttVal(
                                    `${l.subLoopUrl}/${n}`) == undefined ? '--' :
                                parseFloat(Number(this.$store.getters.mqttVal(
                                    `${l.subLoopUrl}/${n}`)).toFixed(2))
                        })
                        data.push(obj)
                    })
                })
                return data
            },
        },
        watch: {
            tableData(n, o) {
                this.all = n.length
            }
        },
        created() {
            connect()
            publishConnect()
            GET_AREAS().then(res => {
                this.areaId = res.data.data.areas[0].areaId
                this.getLoops()

                GET_WireByProjectId().then(res => {
                    this.wireList = res.data.data.result
                    this.getCurrentWireURL()
                })
            })
        },
        mounted() {
            subscribeByNodes(this.nodes)
        },
        beforeDestroy() {
            unsubscribeByNodes(this.nodes)
            this.loops.forEach(item => {
                if (item.switchStatus)
                    unsubscribebyLoopUrl(item.switchStatus)
                if (item.distantStatus)
                    unsubscribebyLoopUrl(item.distantStatus)
                if (item.errorStatus)
                    unsubscribebyLoopUrl(item.errorStatus)
            })
            destroyConnection()
            publishDestroyConnection()
        },
        methods: {
            loopDetail(cmd, loopName) {
                debugger
                this.showLoopDetail = true
                this.currentLoopUrl = loopName
                if (cmd == 'SwitchingClosing') {
                    this.currentLoopTab = '控制'
                } else if (cmd == 'RealTimeData') {
                    this.currentLoopTab = '电力数据'
                }
            },
            getLoops() {
                GET_AREA_LOOPS(this.areaId).then(res => {
                    this.loops = res.data.data.loops
                    this.loops.forEach(item => {
                        if (item.switchStatus)
                            subscribebyLoopUrl(item.switchStatus)
                        if (item.distantStatus)
                            subscribebyLoopUrl(item.distantStatus)
                        if (item.errorStatus)
                            subscribebyLoopUrl(item.errorStatus)
                    })
                    let loopsIdArr = []
                    this.loops.map(item => {
                        loopsIdArr.push(item.loopId)
                    })
                    this.loopsIdArr = loopsIdArr
                    this.requestValues()
                })
            },
            getCurrentWireURL() {
                this.currentWireURL = this.wireList.find(item => item.areaId == this.areaId).url
            },
            getDetailData() {
                this.showTable = true
                this.getPages()
            },
            changeSite(value) {
                this.areaId = value
                this.getCurrentWireURL()
                this.getLoops()
                this.showTable = false
                this.getPages()
            },
            handleTabClick(tab, event) {
                if (tab.name == '电压') {
                    this.extremNodes = ['Ua', 'Ub', 'Uc']
                } else if (tab.name == '电流') {
                    this.extremNodes = ['Ia', 'Ib', 'Ic']
                } else if (tab.name == '功率') {
                    this.extremNodes = ["PA", "PR", "P", "PF"]
                } else if (tab.name == '不平衡度') {
                    this.extremNodes = ["U_unbl", "I_unbl"]
                }
                this.currentTableData = []
                this.first = 0
                this.end = 0
                this.all = 0
                this.getPages()
            },
            timeGenerate(time) {
                let date = new Date(time);
                return dateFormat("HH:MM:SS", date)
            },
            async requestValues() {
                this.requestRes = []
                if (this.loopsIdArr.length === 0 || this.extremNodes.length === 0) {
                    return
                }
                let res = []
                try {
                    res = await Promise.all([
                        EXTREMUM_VALUES(this.loopsIdArr, this.extremNodes, "MAX", new Date()),
                        EXTREMUM_VALUES(this.loopsIdArr, this.extremNodes, "MIN", new Date()),
                    ])
                } catch (e) {

                } finally {
                    this.requestRes = res
                    return res
                }
            },
            arraySpanMethod({
                row,
                column,
                rowIndex,
                columnIndex
            }) {
                let i = this.extremNodes.length
                if (columnIndex === 0 && i > 1) {
                    if (rowIndex % i !== 0) {
                        return [0, 0]
                    } else {
                        return [i, 1]
                    }
                }
            },
            async getPages() {
                await this.requestValues()
                if (this.all == 0) {
                    this.first = 0
                    this.end = 0
                    this.currentTableData = []
                } else {
                    this.first = 1
                    this.end = this.all < 12 ? this.all : 12
                    this.currentTableData = this.tableData.slice(this.first - 1, this.end)
                }
            },
            prev() {
                let length = this.tableData.length
                this.first = this.first - 12 < 1 ? 1 : this.first - 12
                this.end = this.first + 11 > length ? length : this.first + 11
                this.currentTableData = this.tableData.slice(this.first - 1, this.end)
            },
            next() {
                let length = this.tableData.length
                this.first = (this.first + 12) < length ? (this.first + 12) : this.first
                this.end = this.end + 12 < length ? this.end + 12 : length
                this.currentTableData = this.tableData.slice(this.first - 1, this.end)
            },
            getUnit(n) {
                if (n == 'Ua' || n == 'Ub' || n == 'Uc') {
                    return '(V)'
                } else if (n == 'Ia' || n == 'Ib' || n == 'Ic') {
                    return '(A)'
                } else if (n == 'U_unbl' || n == 'I_unbl') {
                    return '(%)'
                } else if (n == 'PA') {
                    return '(W)'
                } else if (n == 'PR') {
                    return '(var)'
                } else if (n == 'P') {
                    return '(VA)'
                } else {
                    return ''
                }
            },
            getChinese(n) {
                switch (n) {
                    case 'Ua':
                        return 'A相电压'
                    case 'Ub':
                        return 'B相电压'
                    case 'Uc':
                        return 'C相电压'
                    case 'Ia':
                        return 'A相电流'
                    case 'Ib':
                        return 'B相电流'
                    case 'Ic':
                        return 'C相电流'
                    case 'P':
                        return '有功功率'
                    case 'PR':
                        return '无功功率'
                    case 'PA':
                        return '视在功率'
                    case 'PF':
                        return '功率因数'
                    case 'U_unbl':
                        return '电压不平衡度'
                    case 'I_unbl':
                        return '电流不平衡度'
                    default:
                        return ''
                }
            },
            onFull() {
                this.width = 1920
                this.height = 1080
            },
            onCancelFull() {
                this.width = 1600
                this.height = 870
            },
        }
    };
</script>

<style lang="less" scoped>
    .content {
        .w(1600);
        .h(968);
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;

        .header {
            .w(1600);
            .h(96);
            background: #FFFFFF;
            box-shadow: 0px 0px 16px 0px rgba(0, 43, 102, 0.04);
        }

        .body {
            width: 100%;
            .h(870);
            background: #eee;
            position: relative;
        }

        .tableBody {
            .w(1473);
            .h(705);
            background: #fff;
            opacity: 1;
            overflow-y: hidden;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);

            transition: all 0.5s;

            .title {
                width: 100%;
                .h(65);
                padding: 0 240/192vw;
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: space-between;
                border-bottom: 1px solid rgba(0, 0, 0, 0.06);
                font-size: 18rem;
                font-weight: bold;
                color: #333333;

                img {
                    cursor: pointer;
                }
            }

            .tab {
                padding: 0 240/192vw;
            }

            .table {
                width: 100%;
                height: 55vh;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
            }
        }

        .pagination {
            height: 6vh;
            .w(300);
            align-self: flex-end;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-evenly;
            font-size: 14rem;

            .button {
                .w(74);
                .h(24);
                border: 1px solid rgba(0, 0, 0, 0.15);
                border-radius: 2px;
                cursor: pointer;
                display: flex;
                justify-content: center;
                align-items: center;
            }
        }
    }

    .tip {
        width: 100%;
        height: 100%;
        font-size: 16rem;
        color: #8c939d;
    }

    .loading {
        width: 28rem;
        height: 28rem;
        animation: loading 1s linear infinite;
    }

    @keyframes loading {
        0% {
            transform: rotate(0);
        }

        100% {
            transform: rotate(360deg);
        }
    }

    // .tableContainer-enter,
    // .tableContainer-leave-to {
    //     opacity: 0;
    // }

    // .tableContainer-enter-active,
    // .tableContainer-leave-active {
    //     transition: all 0.5s
    // }
</style>